import React, { useContext } from 'react'
import { toast } from 'react-toastify'

import { Button } from '@clientbase/clientbase-library'
import { NegativationService } from 'services/NegativationService'

import { toastProps } from 'utils/types/toast-props'

import { FormNegativationContext } from '../context'
import { NegativationSteps, StepsEnum } from '../utils'

const ButtonStep: React.FC = () => {
  const {
    step,
    billingSelected,
    infosCustomer,
    billings,
    fromRef,
    acceptTerm,
    updateStep,
    updateConfirmationDialog
  } = useContext(FormNegativationContext)

  const backStep = () => {
    const objDiv = document.getElementById('modal') as HTMLElement
    objDiv.scrollIntoView({ behavior: 'smooth' })

    updateStep((prevState) => prevState - 1)
  }

  const nextStep = async () => {
    const objDiv = document.getElementById('modal') as HTMLElement

    if (step === StepsEnum[NegativationSteps.REVISION]) {
      objDiv.scrollIntoView({ behavior: 'smooth' })
      fromRef?.current?.requestSubmit()
    } else if (step === StepsEnum[NegativationSteps.ACTIVATION]) {
      if (acceptTerm) {
        const id = toast.loading('Criando negativação...')
        const response = await NegativationService.createNegativation({
          billing_uuid: billingSelected?.uuid,
          customer_uuid: infosCustomer?.uuid
        })

        if (!response?.error) {
          toast.update(id, {
            render: response?.data?.message,
            type: 'success',
            ...toastProps
          })
          updateConfirmationDialog({
            open: true,
            uuid: response?.data?.record?.uuid
          })
        } else {
          toast.update(id, {
            render: response?.message,
            type: 'error',
            ...toastProps
          })
        }
      } else {
        toast.error('Aceite os termos para prosseguir.')
      }
    } else {
      if (!billingSelected) {
        toast.info('Selecione uma cobrança antes de continuar.')
      } else {
        objDiv.scrollIntoView({ behavior: 'smooth' })
        updateStep((prevState) => prevState + 1)
      }
    }
  }

  const labelNext =
    step === StepsEnum[NegativationSteps.ACTIVATION]
      ? 'Solicitar negativação'
      : 'Próximo'

  return (
    <>
      {step === StepsEnum[NegativationSteps.REVISION] && billings === null
        ? null
        : step !== StepsEnum[NegativationSteps.SELECT] && (
            <Button variantButton="neutral" onClick={backStep}>
              Voltar
            </Button>
          )}

      <Button
        variantButton="primary"
        disabled={
          step === StepsEnum[NegativationSteps.ACTIVATION] && !acceptTerm
        }
        onClick={nextStep}
      >
        {labelNext}
      </Button>
    </>
  )
}

export default ButtonStep
